module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "pump-icon.8fccb34f.png";